'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterStoreSwitcher = function () {
  function FooterStoreSwitcher(el) {
    (0, _classCallCheck3.default)(this, FooterStoreSwitcher);

    var context = { context: el };

    this.els = {
      el: el,
      flag: (0, _functional.getElement)('[data-el="footer-language-switcher.flag"]', context),
      select: (0, _functional.getElement)('[data-el="footer-language-switcher.select"]', context),
      options: (0, _functional.getElements)('[data-el="footer-language-switcher.option"]', context)
    };

    this.setupListeners();
  }

  (0, _createClass3.default)(FooterStoreSwitcher, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.onSelectChange = this.onSelectChange.bind(this);
      this.els.select.addEventListener('change', this.onSelectChange);
    }
  }, {
    key: 'onSelectChange',
    value: function onSelectChange(event) {
      var selectedOption = event.target.options[event.target.selectedIndex];
      var newUrl = new URL(window.location.href);
      var pathnameSplit = newUrl.pathname.split('/');

      this.updateFlag(selectedOption.dataset.flagImageSrc);

      if (pathnameSplit.length > 2) {
        newUrl.pathname = newUrl.pathname.replace('/' + pathnameSplit[1], '');
      } else {
        newUrl.pathname = '/' + selectedOption.dataset.iso + newUrl.pathname;
      }

      window.location.href = newUrl.toString();
    }
  }, {
    key: 'updateFlag',
    value: function updateFlag(img) {
      if (!img) {
        this.els.flag.style.opacity = 0;
        return;
      }

      this.els.flag.src = img || '';
    }
  }]);
  return FooterStoreSwitcher;
}();

exports.default = FooterStoreSwitcher;